import { SVGProps } from 'react';

export const GatewayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M28.167 9.194a9.192 9.192 0 0 1 13 0m-9.75 4.333a4.598 4.598 0 0 1 6.5 0m-9.75 23.307h-13m19.5-8.667V19.5m-.076 17.41a.107.107 0 0 1 0-.154.107.107 0 0 1 .154 0 .107.107 0 0 1 0 .154.107.107 0 0 1-.154 0Zm-23.758-8.743h30.334A4.332 4.332 0 0 1 45.5 32.5v8.667a4.332 4.332 0 0 1-4.333 4.333H10.833A4.332 4.332 0 0 1 6.5 41.167V32.5a4.332 4.332 0 0 1 4.333-4.333Z'
    />
  </svg>
);
